// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDocBhTS7bG4sTwxCf6D2PBta8TJIoHXsE",
  authDomain: "global-multiservicios.firebaseapp.com",
  projectId: "global-multiservicios",
  storageBucket: "global-multiservicios.appspot.com",
  messagingSenderId: "353620818044",
  appId: "1:353620818044:web:865d6de1e6749cffc3f1f9"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app); // ✅ Agregado
const auth = getAuth(app);

export { db, storage, auth };
